import type {
  OpsNamespaceRefreshSkuNamesResponse,
  OpsNamespaceRenamePreflightResponse,
  OpsNamespaceRenameRequest,
  OpsNamespaceRenameResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * `/v1/ops/namespaces/*` — namespace slug rename orchestration (#996).
 * Namespaces are channels; these endpoints wrap the platform rename plus the
 * gateway sku_name snapshot refresh with explicit partial-failure reporting.
 */

export function getNamespaceRenamePreflight(
  id: string,
  days: number | undefined,
  fetchImpl: typeof fetch = fetch,
): Promise<OpsNamespaceRenamePreflightResponse> {
  const qs = days === undefined ? '' : `?days=${encodeURIComponent(String(days))}`;
  return opsApiRequest<OpsNamespaceRenamePreflightResponse>(
    `/v1/ops/namespaces/${encodeURIComponent(id)}/rename-preflight${qs}`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function renameNamespace(
  id: string,
  body: OpsNamespaceRenameRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<OpsNamespaceRenameResponse> {
  return opsApiRequest<OpsNamespaceRenameResponse>(
    `/v1/ops/namespaces/${encodeURIComponent(id)}/rename`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
    },
    fetchImpl,
  );
}

export function refreshNamespaceSkuNames(
  id: string,
  fetchImpl: typeof fetch = fetch,
): Promise<OpsNamespaceRefreshSkuNamesResponse> {
  return opsApiRequest<OpsNamespaceRefreshSkuNamesResponse>(
    `/v1/ops/namespaces/${encodeURIComponent(id)}/refresh-sku-names`,
    { method: 'POST' },
    fetchImpl,
  );
}
